import Check from '@mui/icons-material/Check';
import * as styles from './AccountRow.css';

type AccountRowProps = {
  label: string;
  Logo: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  logoClassName?: string;
  connected: boolean;
  isLoading: boolean;
  onConnect: () => void;
  onDisconnect: () => void;
};

export const AccountRow = ({
  label,
  Logo,
  logoClassName,
  connected,
  isLoading,
  onConnect,
  onDisconnect,
}: AccountRowProps) => {
  const statusText = connected ? 'Connected' : 'Not connected';
  const buttonText = connected ? 'Disconnect' : 'Connect';

  return (
    <div className={styles.row}>
      <div className={styles.logoLabel}>
        <Logo className={logoClassName ?? styles.logo} />
        <span className={styles.label}>{label}</span>
      </div>

      <div className={styles.statusBadge}>
        {connected && <Check className={styles.statusIconConnected} />}
        <span
          className={
            connected
              ? styles.statusTextConnected
              : styles.statusTextDisconnected
          }
        >
          {statusText}
        </span>
      </div>

      <button
        className={styles.actionButton}
        onClick={connected ? onDisconnect : onConnect}
        disabled={isLoading}
      >
        {buttonText}
      </button>
    </div>
  );
};
